/**
 * @kind ko binding handler
 * @name autoSelect
 * @description Selects an input's content on focus/click when enabled.
 **/
ko.bindingHandlers.autoSelect = {
	init: function (element, valueAccessor) {
		const select_all_text = () => {
			const enabled = ko.utils.unwrapObservable(valueAccessor());
			if (!enabled || element.disabled || element.readOnly)
				return;

			if (typeof element.select === 'function')
			{
				try
				{
					element.select();
				}
				catch (_err)
				{
					// Some input types do not support select().
				}
			}
		};

		element.addEventListener('focus', select_all_text);
		element.addEventListener('click', select_all_text);

		ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
			element.removeEventListener('focus', select_all_text);
			element.removeEventListener('click', select_all_text);
		});
	}
};

export default 'bindings';
